import * as React from 'react';
import { useState } from 'react';
import { Box, FormLabel, TextField, Button, Typography, Link, InputAdornment, IconButton } from '@mui/material';
import '../css/login.css';
import { LoginApi } from '../../api/login/login.ts';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        LoginApi(email, password);
    };

    return (
        <Box
            component="section"
            className="box-login"
            boxShadow={3}
        >
            <Typography variant="h4" component="h1" gutterBottom>
                Iniciar Sesión
            </Typography>

            <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{ width: '100%', mt: 1 }}
            >
                <FormLabel htmlFor="outlined-email-input" sx={{ mb: 1, display: 'block', fontSize: 20 }}>
                    Correo Electrónico
                </FormLabel>
                <TextField
                    size="medium"
                    required
                    fullWidth
                    id="outlined-email-input"
                    type="email"
                    autoComplete="email"
                    margin="normal"
                    variant="outlined"
                    placeholder='micorreo@******.com'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />

                <FormLabel htmlFor="outlined-password-input" sx={{ mb: 1, display: 'block', mt: 2, fontSize: 20 }}>
                    Contraseña
                </FormLabel>
                <TextField
                    required
                    fullWidth
                    id="outlined-password-input"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="********"
                    margin="normal"
                    variant="outlined"
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label={showPassword ? 'ocultar contraseña' : 'mostrar contraseña'}
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />

                <Button
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2, fontSize: 20 }}
                    type="submit"
                >
                    Iniciar Sesión
                </Button>
                <Link href="/forget-password" underline="hover" sx={{ justifyContent: 'center', display: 'flex', fontSize: 20 }}>
                    ¿Olvidaste tu contraseña?
                </Link>
            </Box>
        </Box>
    );
};

export default Login;